import styled from 'styled-components';

export const Container = styled.footer`
  margin-top: auto;
  border-top: 1px solid hsl(var(--foreground) / 0.05);
  background: linear-gradient(
    180deg,
    hsl(var(--background)) 0%,
    hsl(var(--card) / 0.96) 100%
  );
`;

export const Content = styled.div`
  max-width: 1400px;
  padding: 46px 3rem 22px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 420px);
  gap: 56px;
  align-items: start;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
    gap: 30px;
    padding: 38px 1rem 18px;
  }

  @media (max-width: 640px) {
    text-align: center;
    justify-items: center;
    gap: 26px;
  }
`;

export const Brand = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  max-width: 520px;

  .brand-link {
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    width: fit-content;
  }

  .adopet-logo {
    width: min(100%, 142px);
    height: auto;
    display: block;
    object-fit: contain;
    filter: drop-shadow(0 10px 22px hsl(var(--primary) / 0.1));
  }

  .desc {
    color: hsl(var(--muted-foreground));
    font-size: 14px;
    line-height: 1.72;
    max-width: 420px;
    font-weight: 600;
  }

  .city {
    color: hsl(var(--foreground));
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 0.04em;
    opacity: 0.82;
  }

  .contact-email {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    width: fit-content;
    color: hsl(var(--accent));
    font-size: 13px;
    font-weight: 700;
    text-decoration: none;
    opacity: 0.9;
    transition: opacity 0.2s ease;

    svg {
      flex-shrink: 0;
    }
  }

  .contact-email:hover {
    opacity: 1;
    text-decoration: underline;
    text-underline-offset: 3px;
  }

  @media (max-width: 640px) {
    align-items: center;
    max-width: 100%;

    .brand-link {
      justify-content: center;
    }

    .desc {
      max-width: 320px;
    }
  }
`;

export const LegalLinks = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  margin-top: 8px;

  a {
    color: hsl(var(--foreground));
    opacity: 0.88;
    text-decoration: underline;
    text-underline-offset: 3px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1.5;
    transition: opacity 0.2s ease, color 0.2s ease;
  }

  a:hover {
    opacity: 1;
    color: hsl(var(--accent));
  }

  @media (max-width: 640px) {
    justify-content: center;
    align-items: center;
    max-width: 320px;
    gap: 10px 12px;
    text-align: center;
  }
`;

export const Institutional = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  max-width: 420px;
  justify-self: end;

  .eyebrow {
    color: hsl(var(--accent));
    font-size: 11px;
    font-weight: 900;
    letter-spacing: 0.16em;
    text-transform: uppercase;
  }

  .biga-link {
    display: inline-flex;
    width: fit-content;
    text-decoration: none;
  }

  .biga-logo {
    width: 78px;
    height: 78px;
    object-fit: contain;
    display: block;
    filter: drop-shadow(0 10px 20px hsl(var(--primary) / 0.08));
    opacity: 0.96;
  }

  .company-text {
    display: flex;
    flex-direction: column;
    gap: 6px;
    color: hsl(var(--muted-foreground));
    font-size: 13px;
    line-height: 1.65;
  }

  .company-text strong {
    color: hsl(var(--foreground));
    font-size: 14px;
    font-weight: 900;
  }

  .company-text a {
    width: fit-content;
    color: hsl(var(--sky));
    text-decoration: none;
    font-weight: 800;
    transition: opacity 0.2s ease;
  }

  .company-text a:hover {
    opacity: 0.85;
  }

  @media (max-width: 980px) {
    justify-self: start;
  }

  @media (max-width: 640px) {
    align-items: center;
    justify-self: center;
    text-align: center;

    .biga-link,
    .company-text a {
      margin: 0 auto;
    }

    .company-text {
      align-items: center;
      max-width: 330px;
    }
  }
`;

export const BottomBar = styled.div`
  max-width: 1400px;
  padding: 0 3rem 28px;
  margin: 0 auto;

  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: center;

  .line {
    color: hsl(var(--muted-foreground));
    font-size: 13px;
    display: inline-flex;
    align-items: center;
    gap: 6px;

    svg {
      color: hsl(var(--primary));
      filter: drop-shadow(0 0 10px hsl(var(--primary) / 0.5));
      animation: footer-heart 1.5s ease-in-out infinite;
    }
  }

  .copy {
    color: hsl(var(--muted-foreground) / 0.65);
    font-size: 12px;
    text-align: right;
  }

  @keyframes footer-heart {
    0%,
    100% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.3);
    }
  }

  @media (max-width: 980px) {
    padding: 0 1rem 24px;
  }

  @media (max-width: 640px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 10px;

    .copy {
      text-align: center;
    }
  }
`;
